/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExternalAcademicUserLoginDTO
 */
export interface ExternalAcademicUserLoginDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserLoginDTO
	 */
	email: string;
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserLoginDTO
	 */
	password: string;
}

export function ExternalAcademicUserLoginDTOFromJSON(
	json: any
): ExternalAcademicUserLoginDTO {
	return ExternalAcademicUserLoginDTOFromJSONTyped(json, false);
}

export function ExternalAcademicUserLoginDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ExternalAcademicUserLoginDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		email: json["email"],
		password: json["password"],
	};
}

export function ExternalAcademicUserLoginDTOToJSON(
	value?: ExternalAcademicUserLoginDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		email: value.email,
		password: value.password,
	};
}
